"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = WizardContextProvider;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Context = require("../Context");

var _GenericStore = require("../components/store/GenericStore");

function WizardContextProvider(props) {
  var path = props.path;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      onCancel = _useState2[0],
      setOnCancel = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      onNext = _useState4[0],
      setOnNext = _useState4[1];

  var getData = function getData() {
    return _GenericStore.dataStore.getValue(path);
  };

  return /*#__PURE__*/_react["default"].createElement(_Context.ContextProvider, {
    value: {
      onCancel: onCancel,
      setOnCancel: setOnCancel,
      onNext: onNext,
      setOnNext: setOnNext,
      getData: getData
    }
  }, props.children);
}